import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { baseApiCall } from "src/api/Api";
import {
  BackButton,
  Button,
  CustomTab,
  Loader,
  UpdateStrategyModal,
} from "src/components";
import { Title, commonVaribles } from "src/constants/constVariables";
import { plasticPackagingRecyclingGuidelines, recycledContentGuidelines, tataLogoBase64 } from 'src/constants/constant.js';
import useAuthorizationContext from "src/providers/AuthorizationHandler/useAuthorizationContext";

import {
  packaging_strategy_view_all_endpoints,
  packaging_strategy_all_endpoints,
} from "src/constants/url";

import globalstyle from "src/assets/scss/global.module.scss";

import styles from "./PackagingStrategyDetails.module.scss";
import clsx from "clsx";
import logo from "src/assets/images/tata-logo.png";
import ImageComponent from "src/components/Atoms/ImageComponent/ImageComponent";
import { constants } from "src/constants/constant";
import { hasEditAccess } from "src/authorization/authorizationsConstants";
import { FeedBackFormModal } from "src/components/Modals/FeedBackFormModal";
import { convertUTCtoIST, formatDate, IsUserRoleMatch, replacingComma } from "src/constants/utils";
import { store } from "src/redux";
import axios from "axios";
import { useDispatch } from "react-redux";
import { onResponse } from "src/redux/features";
import { AnnexureModal } from "src/components/Modals/AnnexureModal";
import { usePDF } from "react-to-pdf";
import { FeedbackModal } from "src/components/Modals/FeedbackModal";
import { patchDataIntoExcel } from "src/constants/excelUtils";
import moment from "moment";

export function PackagingStrategyDetails() {
  const navigate = useNavigate();
  const { user } = useAuthorizationContext();
  const [viewData, setViewData] = useState([]);
  const [loader, setLoader] = useState(false);
  const { state } = useLocation();
  const [dataset, setDataset] = useState([]);
  const [isFeedBackModalOpen, setIsFeedBackModalOpen] = useState(false);
  const [excelfile, setexcelfile] = useState();
  const [isUpdateStrategyModalOpen, SetIsUpdateStrategyModalOpen] =
    useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [ismodalLoader, SetModalloader] = useState(false);
  const [isAnnexureModalOpen, setAnnexureModalOpen] = useState(false);
  const [isDownloadTrue, setIsDownloadTrue] = useState(false);

  const search = state?.search;
  const parsedRow = state?.data ? JSON.parse(state.data) : null;
  const viewAccess = true;

  const dispatch = useDispatch();
  //function for the opening of the insertion dialog for the excel file.
  const openExcelUploadFile = () => {
    document.getElementById("input_file").value = "";
    document.getElementById("input_file").click();
  };

  const handleExcelUpload = async (e) => {
    // **Corrected variable name here**
    const selectedFiles = e.target.files[0];
    const validExcelFiles = /\.(csv|xlsx|xls|xlsm)$/i.test(selectedFiles.name);
    if (validExcelFiles) {
      setexcelfile(selectedFiles);
    } else {
      setErrorMessage(commonVaribles.excelErrormsg);
    }
  };

  const handleUpload = async () => {
    SetModalloader(true);
    if (!excelfile) return;
    const formData = new FormData();
    const seletctedPlant = store.getState().allPlants.plantName;
    const defaultValue = store.getState().allPlants.plants;
    const plantId = seletctedPlant.value
      ? seletctedPlant.value
      : defaultValue[0]?.value;
    formData.append("excel_file", excelfile);
    formData.append("plant_id", parsedRow.plant_id);
    formData.append("user_name", user.name);
    formData.append("strategy_id", parsedRow.id);

    try {
      const response = await axios.post(
        packaging_strategy_all_endpoints.POST_UPDATE_STRATEGY_EXCEL_UPLOAD,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + store.getState().loginAuth.token,
          },
        }
      );
      dispatch(
        onResponse({
          isToaster: true,
          severity: commonVaribles.success,
          message: commonVaribles.file_upload_successfully,
        })
      );
      SetModalloader(false);
      SetIsUpdateStrategyModalOpen(false);
      setexcelfile();
    } catch (error) {
      dispatch(
        onResponse({
          isToaster: true,
          severity: commonVaribles.error,
          message: commonVaribles.file_upload_failed,
        })
      );
      SetModalloader(false);
    }
  };

  const handleCloseAnnexureModal = () => {
    setAnnexureModalOpen(false);
  };

  const fetchPartRows = () => {
    setLoader(false);
    baseApiCall({
      url: packaging_strategy_view_all_endpoints.GET_PACKAGING_STRATERGIES_VIEW_BY_ID,
      requestBody: {
        strategy_id: parsedRow.id,
        plant_id: parsedRow.plant_id,
        Skipinterceptors: true,
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res && res.data && res.data.result && res.data.result !== "") {
          const data = res.data.result;
          setViewData(data);
          setLoader(true);
          const dataView = {
            tmlReceivingLocation:
              data?.Strategies_table?.part_info_data?.receiving_location,
            partNo: data?.Strategies_table?.part_info_data?.part_no,
            packageDetailsData: [
              {
                detailsHeader: "Packaging strategy / Material used ",
                tmlApprovedValue:
                  data?.Strategies_table?.secondary_packaging_info
                    ?.secondary_packaging_material,
                actualApprovedValue: "",
                receivingPlantLocation: "",
              },
              {
                detailsHeader: "Quantity of parts received per box / Pallet",
                tmlApprovedValue:
                  data?.Strategies_table?.secondary_packaging_info
                    ?.secondary_density,
                actualApprovedValue: "",
                receivingPlantLocation: "",
              },
              {
                detailsHeader: "Packaging dimension (Length * Width * Height)",
                tmlApprovedValue: replacingComma(
                  data?.Strategies_table?.secondary_packaging_info
                    ?.secondary_outside_dimension
                ),
                actualApprovedValue: "",
                receivingPlantLocation: "",
              },
            ],
          };
          setDataset(dataView);
        } else {
          setLoader(true);
        }
      },
      onFailure: () => {
        setLoader(false);
        navigate("/packaging-strategy", { state: { search } });
      },
      errorCall: () => {
        setLoader(false);
        navigate("/packaging-strategy", { state: { search } });
      },
    });
  };

  useEffect(() => {
    if (parsedRow?.id) {
      fetchPartRows();
    } else {
      navigate("/packaging-strategy", { state: { search } });
    }
  }, []);

  const { toPDF, targetRef } = usePDF({
    filename: `${parsedRow?.part_no}_${parsedRow?.vendor_code}.pdf`,
    page: {
      margin: 10,
    },
  });

  const handleDownloadExcelFile = () => {
    if (viewData?.Strategies_table?.file_name) {
      baseApiCall({
        url: packaging_strategy_all_endpoints.GET_PRESIGNED_IMAGES,
        requestBody: {
          img_type: "logistics-excel-sheet",
          file_name: viewData?.Strategies_table?.file_name,
          Skipinterceptors: true,
        },
        method: commonVaribles.post,
        onSuccess: (res) => {
          if (res && res.data && res.data.result && res.data.result !== "") {
            const imagePath = res.data.result;
            if (imagePath) {
              const xhr = new XMLHttpRequest();
              xhr.open("GET", imagePath, true);
              xhr.responseType = "blob";
              xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                  if (xhr.status === 200) {
                    const blob = xhr.response;
                    const file = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = file;
                    a.download = viewData?.Strategies_table?.file_name;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                  } else {
                    console.error("Request failed with status:", xhr.status);
                  }
                  setLoader(true);
                }
              };
              xhr.send();
            } else {
              dispatch(
                onResponse({
                  isToaster: true,
                  severity: commonVaribles.error,
                  message: `Failed to Download Excel file`,
                })
              );
            }
            setLoader(true);
          } else {
            dispatch(
              onResponse({
                isToaster: true,
                severity: commonVaribles.error,
                message: `Failed to Download Excel file`,
              })
            );
            setLoader(true);
          }
        },
        onFailure: () => {
          setLoader(false);
        },
        errorCall: () => {
          setLoader(false);
        },
      });
    } else {
      dispatch(
        onResponse({
          isToaster: true,
          severity: commonVaribles.error,
          message: `Excel File is Not Found`,
        })
      );
    }
  };

  const renderGuidelinesTable = (data) => {
    return (
      <div className={styles.guideTable}>
        {data.map((row, rowIndex) => (
          <div key={rowIndex} className={clsx(styles.guideTableRow, rowIndex === 0 ? styles.guideTableHeader : styles.guideTableData)}>
            {row.map((cell, cellIndex) => (
              <div key={cellIndex} className={styles.guideTableCell}>
                {cell}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const handleDownloadPDF = () => {
    const additionalText = "Additional Text";
    const content = targetRef.current.innerHTML + additionalText;
    toPDF(content).then(() => {
      setIsDownloadTrue(false);
    });
  };

  const handleDownloadExcelFile_V2 = () => {
		if (commonVaribles.sample_excel_template_name) {
			setLoader(false);
			baseApiCall({
				url: packaging_strategy_all_endpoints.GET_PRESIGNED_IMAGES,
				requestBody: {
					img_type: commonVaribles.sample_excel_template_folder,
					file_name: commonVaribles.sample_excel_template_name,
					Skipinterceptors: true,
				},
				method: commonVaribles.post,
				onSuccess: async (res) => {
					try {
						if (res && res.data && res.data.result) {
							const templateUrl = res.data.result;

							// Fetch the data to patch
							const patchData = await fetchYourApiEndpointForPatchData();

							const templateFileName =
								patchData?.Strategies_table?.plant_id +
								'_' +
								patchData?.Strategies_table?.supply_info_data?.vendor_code +
								'_' +
								patchData?.Strategies_table?.part_info_data?.part_no +
								'_' +
								convertUTCtoIST(moment());

							// Define key-value mappings (keys are in the cells, and the values are the data to patch)
							const mappings = [
								//supply_info_data
								{
									key: 'Company Name',
									value:
										patchData?.Strategies_table?.supply_info_data?.company_name,
								},
								{
									key: 'Vendor Code',
									value:
										patchData?.Strategies_table?.supply_info_data?.vendor_code,
								},
								{
									key: 'Company Address',
									value:
										patchData?.Strategies_table?.supply_info_data
											?.company_address,
								},
								{
									key: 'State, Country :',
									value: patchData?.Strategies_table?.supply_info_data?.state,
								},
								{
									key: 'Pkg Person Contact Name: - ',
									value:
										patchData?.Strategies_table?.supply_info_data
											?.contact_person,
								},
								{
									key: 'Tel No: -',
									value: patchData?.Strategies_table?.supply_info_data?.tel_no,
								},
								{
									key: 'E-mail: - ',
									value: patchData?.Strategies_table?.supply_info_data?.email,
								},
								{
									key: 'Fax No: - ',
									value: patchData?.Strategies_table?.supply_info_data?.fax_no,
								},

								//approval_info
								{
									key: 'Approval Type: - ',
									value:
										patchData?.Strategies_table?.approval_info?.approval_type,
								},
								{
									key: 'STATUS',
									value:
										patchData?.Strategies_table?.approval_info?.approval_status,
								},
								{
									key: 'Date of Approval: - ',
									value: patchData?.Strategies_table?.approval_info
										?.approval_date
										? formatDate(
												patchData?.Strategies_table?.approval_info
													?.approval_date
											)
										: '-',
								},
								{
									key: 'Packaging Person (Supplier): - ',
									value:
										patchData?.Strategies_table?.approval_info
											?.packaging_person,
								},
								{
									key: 'Purchasing Buyer (TMPVL/TPEM): - ',
									value:
										patchData?.Strategies_table?.approval_info
											?.purchasing_buyer,
								},
								{
									key: 'SCM ( TMPVL/TPEM)- ',
									value: patchData?.Strategies_table?.approval_info?.scm,
								},

								//part_info_data
								{
									key: 'A. TATA MOTORS Receiving Location: - ',
									value:
										patchData?.Strategies_table?.part_info_data
											?.receiving_location,
								},
								{
									key: 'B. Part No: - ',
									value: patchData?.Strategies_table?.part_info_data?.part_no,
								},
								{
									key: 'C. Part Description: - ',
									value:
										patchData?.Strategies_table?.part_info_data
											?.part_description,
								},
								{
									key: 'D. Part Weight (Kg): - ',
									value:
										patchData?.Strategies_table?.part_info_data?.part_weight,
								},
								{
									key: 'E. Part Dimensions (L X W X H) (mm): - ',
									value:
										patchData?.Strategies_table?.part_info_data?.part_dimension,
								},
								{
									key: 'F. Annual Volume (Projected): - ',
									value:
										patchData?.Strategies_table?.part_info_data?.annual_volume,
								},
								{
									key: 'G. No. of parts per vehicle: - ',
									value:
										patchData?.Strategies_table?.part_info_data
											?.part_per_vehicle,
								},
								{
									key: 'H. Models applicable: - ',
									value:
										patchData?.Strategies_table?.part_info_data
											?.models_applicable,
								},
								{
									key: 'I. Packaging Cost / Part: - ',
									value:
										patchData?.Strategies_table?.part_info_data
											?.supplier_packaging_cost,
								},
								{
									key: 'J. Transportation Cost / Part: - ',
									value:
										patchData?.Strategies_table?.part_info_data
											?.supplier_transport_cost,
								},

								//primary_packaging_info
								{
									key: 'A. Density (Qty of parts): - ',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_density,
								},
								{
									key: 'B. Packaging Strategy: - ',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_density,
								},
								{
									key: 'C. Carton Code: - ',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_carton_code,
								},
								{
									key: 'D. Carton Type (Design): - ',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_carton_type,
								},
								{
									key: 'E. Packaging Material Type: - ',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_packaging_material,
								},
								{
									key: 'F. Securement / Closure Type: - ',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_securement,
								},
								{
									key: 'G. Total Loaded Wt. (Kg - Full)',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_total_Loaded,
								},
								{
									key: 'K. Container Ownership',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_container_ownership,
								},
								{
									key: 'L. Type of Plastic Packaging Supplied Along with Parts',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_type_of_plastic_packaging_supplied,
								},
								{
									key: 'M. Is the packaging collected and taken back by Supplier ',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_is_the_packaging_collected,
								},
								{
									key: 'N. Are you complying to PWM EPR Rules (Plastic Waste Management)',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_complying_to_pwm_epr_rules,
								},
								{
									key: 'O. Share your PWM EPR Registration No. (As a brand owner)',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_pwm_epr_registration_no,
								},
								{
									key: 'P. Share your plastic packaging supplier PWM EPR Registration Number (As a producer/manufacturer)',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_plastic_packaging_supplier_pwm_epr_registration_no,
								},
								{
									key: 'Q. Are you complying with the PWM EPR Labeling Requirement',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_pwm_epr_labeling_requirement,
								},
								{
									key: 'R. Are you complying with the PWM EPR Plastic Packaging Recycling Requirement',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_pwm_epr_plastic_packaging_recycling_requirement,
								},
								{
									key: 'S. Are you complying with the PWM EPR Plastic Packaging Recycled Content Requirement',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_pwm_epr_plastic_packaging_recycled_content_requirement,
								},
								{
									key: 'T. What is the current % of recycled content in the plastic packaging of the parts',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_current_percent_recycled_content_in_plastic_packaging,
								},
								{
									key: 'U. Remarks/Any Other Details',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_remarks,
								},

								//shipping_info
								{
									key: 'A. Transportation Mode (Vehicle type / Size): - ',
									value:
										patchData?.Strategies_table?.shipping_info
											?.transportation_mode,
								},
								{
									key: 'C. No. of Pallets per vehicle',
									value:
										patchData?.Strategies_table?.shipping_info
											?.no_of_pallets_per_vehicle,
								},

								{
									key: 'E. Sec Packaging per transit modes: - ',
									value:
										patchData?.Strategies_table?.shipping_info
											?.sec_packaging_per_transit_modes,
								},
								{
									key: 'F. No of Pry Packs per Sec Packs: - ',
									value:
										patchData?.Strategies_table?.shipping_info
											?.no_of_pry_packs_per_sec_packs,
								},
								{
									key: 'G. INCO Terms:  -',
									value: patchData?.Strategies_table?.shipping_info?.inco_terms,
								},
								{
									key: 'H. Hazardous Material Class: - ',
									value:
										patchData?.Strategies_table?.shipping_info
											?.hazardous_material_class,
								},
								{
									key: 'I. Loop Size ( for Returnable)',
									value: patchData?.Strategies_table?.shipping_info?.loop_size,
								},
								{
									key: 'J. Life of Returnable Packaging',
									value:
										patchData?.Strategies_table?.shipping_info
											?.life_returnable_packaging,
								},
								{
									key: 'K. Unloading & Loading responsibility',
									value:
										patchData?.Strategies_table?.shipping_info
											?.unloading_loading_responsibility,
								},
								{
									key: 'L. Supply at TMPVL/TPEM ( Supplier Scope)',
									value: patchData?.Strategies_table?.shipping_info?.supply_tml,
								},
							];

							const mappingsBelow = [
								{
									key: 'Theoretical Cubic Utilisation / No of Parts per Transport mode',
									value:
										patchData?.Strategies_table?.shipping_info
											?.theoretical_cubic_utilisation,
								},
								{
									key: 'Remarks',
									value: patchData?.Strategies_table?.shipping_info?.remarks,
								},
							];

							const mappingsSecondRight = [
								//secondary_packaging_info
								{
									key: 'A. Density (Qty of parts): - ',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_density,
								},
								{
									key: 'B. Packaging Strategy: - ',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_packaging_strategy,
								},
								{
									key: 'C. Carton Code: - ',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_carton_Code,
								},
								{
									key: 'D. Carton Type (Design): - ',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_carton_Type,
								},
								{
									key: 'E. Packaging Material Type: - ',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_packaging_material,
								},
								{
									key: 'F. Securement / Closure Type: - ',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_securement,
								},
								{
									key: 'G. Total Loaded Wt. (Kg - Full)',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_total_loaded,
								},
								{
									key: 'K. Container Ownership',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_container_ownership,
								},

								{
									key: 'L. Type of Plastic Packaging Supplied Along with Parts',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_type_of_plastic_packaging_supplied,
								},
								{
									key: 'M. Is the packaging collected and taken back by Supplier ',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_is_the_packaging_collected,
								},
								{
									key: 'N. Are you complying to PWM EPR Rules (Plastic Waste Management)',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_complying_to_pwm_epr_rules,
								},
								{
									key: 'O. Share your PWM EPR Registration No. (As a brand owner)',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_pwm_epr_registration_no,
								},
								{
									key: 'P. Share your plastic packaging supplier PWM EPR Registration Number (As a producer/manufacturer)',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_plastic_packaging_supplier_pwm_epr_registration_no,
								},
								{
									key: 'Q. Are you complying with the PWM EPR Labeling Requirement',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_pwm_epr_labeling_requirement,
								},
								{
									key: 'R. Are you complying with the PWM EPR Plastic Packaging Recycling Requirement',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_pwm_epr_plastic_packaging_recycling_requirement,
								},
								{
									key: 'S. Are you complying with the PWM EPR Plastic Packaging Recycled Content Requirement',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_plastic_packaging_recycled_content_requirement,
								},
								{
									key: 'T. What is the current % of recycled content in the plastic packaging of the parts',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_current_percent_recycled_content_plastic_packaging,
								},
								{
									key: 'U. Remarks/Any Other Details',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_remarks,
								},
							];

							const mappingsSplittingSecondary = [
								{
									key: 'H. Outside Dimension (LXWXH) (mm): -',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_outside_dimension,
								},
								{
									key: 'I. Dunnage & Description: - ',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_dunnage_description,
								},
								{
									key: 'J. Labels (Quantity / Location): - ',
									value:
										patchData?.Strategies_table?.secondary_packaging_info
											?.secondary_labels,
								},
							];

							const mappingsSplittingPrimary = [
								{
									key: 'B. Pallet Dimensions (LXWXH) (mm): - ',
									value:
										patchData?.Strategies_table?.shipping_info
											?.pallet_dimensions,
								},
								{
									key: 'H. Outside Dimension (LXWXH) (mm): -',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_outside_dimension,
								},
								{
									key: 'I. Dunnage & Description: - ',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_dunnage_description,
								},
								{
									key: 'J. Labels (Quantity / Location): - ',
									value:
										patchData?.Strategies_table?.primary_packaging_info
											?.primary_labels,
								},
                {
									key:
										'D. Stackable/ Non stackable (If ' +
										'"' +
										'Stackable' +
										'"' +
										' then no. of stacking allowed)',
									value:
										patchData?.Strategies_table?.shipping_info
											?.stackable_non_stackable,
								},
							];

							const mappingsSplittingApproval = [
								{
									key: 'Packaging Person (Supplier): - ',
									value: patchData?.Strategies_table?.approval_info
										?.packaging_person_date
										? formatDate(
												patchData?.Strategies_table?.approval_info
													?.packaging_person_date
											)
										: '-',
								},
								{
									key: 'Purchasing Buyer (TMPVL/TPEM): - ',
									value: patchData?.Strategies_table?.approval_info
										?.purchasing_buyer_date
										? formatDate(
												patchData?.Strategies_table?.approval_info
													?.purchasing_buyer_date
											)
										: '-',
								},
								{
									key: 'SCM ( TMPVL/TPEM)- ',
									value: patchData?.Strategies_table?.approval_info?.scm_date
										? formatDate(
												patchData?.Strategies_table?.approval_info?.scm_date
											)
										: '-',
								},
							];

							// Example usage with imageMappings
							const imageMappings = [
								{
									key: 'part_only_image',
									value:
										patchData?.Strategies_table?.visual_reference
											?.part_only_image,
									position: 'D22:G31',
								},
								{
									key: 'part_dunnage_primary_packaging_image',
									value:
										patchData?.Strategies_table?.visual_reference
											?.part_dunnage_primary_packaging_image,
									position: 'H22:M31',
								},
								{
									key: 'primary_plus_secondary_packaging_image',
									value:
										patchData?.Strategies_table?.visual_reference
											?.primary_plus_secondary_packaging_image,
									position: 'N22:S31',
								},
							];

							const excelData = {
								mappings: mappings,
								mappingsBelow: mappingsBelow,
								mappingsSecondRight: mappingsSecondRight,
								mappingsSplittingSecondary: mappingsSplittingSecondary,
								mappingsSplittingPrimary: mappingsSplittingPrimary,
								mappingsSplittingApproval: mappingsSplittingApproval,
								imageMappings: imageMappings
							};

							const data = patchDataIntoExcel(
								excelData,
								tataLogoBase64,
								templateUrl,
								templateFileName
							);

							// Ensure loader is stopped after download
							setLoader(true);
						} else {
							throw new Error('Failed to download the template');
							// Ensure loader is stopped after download
							setLoader(true);
						}
					} catch (error) {
						dispatch(
							onResponse({
								isToaster: true,
								severity: commonVaribles.error,
								message: error.message || 'An error occurred',
							})
						);
						// Ensure loader is stopped after download
						setLoader(true);
					}
				},
				onFailure: () => {
					setLoader(true);
				},
				errorCall: () => {
					setLoader(true);
				},
			});
		} else {
			dispatch(
				onResponse({
					isToaster: true,
					severity: commonVaribles.error,
					message: 'Template File is Not Found',
				})
			);
			setLoader(true);
		}
	};

	const fetchYourApiEndpointForPatchData = () => {
		return new Promise((resolve, reject) => {
			setLoader(false);
			baseApiCall({
				url: packaging_strategy_view_all_endpoints.GET_PACKAGING_STRATERGIES_VIEW_BY_ID,
				requestBody: {
					strategy_id: parsedRow.id,
					plant_id: parsedRow.plant_id,
					Skipinterceptors: true,
				},
				method: commonVaribles.post,
				onSuccess: (res) => {
					if (res && res.data && res.data.result && res.data.result !== '') {
						resolve(res.data.result);
					}
					setLoader(true);
				},
				onFailure: () => {
					setLoader(true);
				},
				errorCall: () => {
					setLoader(true);
				},
			});
		});
	};

  return loader ? (
    <div>
      <div className={globalstyle.breadcrumb}>
        <BackButton
          basePath={Title.home}
          action={Title.packaging_strategy_details}
          handleClick={() => {
            navigate("/packaging-strategy", { state: { search } });
          }}
          browserBack={true}
        />
      </div>
      <div>
        <CustomTab
          title={Title.packaging_strategy_details}
          isDatepicker={true}
          isDropdown={false}
          isSelected={false}
          withOutCount={true}
          withOutFilters={true}
          isSubTitleText={true}
          subTitleText={Title.tata_autocomp_systems_ltd_packaging_document}
          setReuploadData={viewData}
          isFeedbackButton={true}
          setIsFeedBackModalOpen={setIsFeedBackModalOpen}
        />
      </div>

      <div className={styles.tablemain} ref={targetRef}>
        {isDownloadTrue && (
          <div className={styles.title}>
            <span>{Title.tata_autocomp_systems_ltd_packaging_document}</span>
          </div>
        )}
        <div className={styles.supplierSection}>
          <div className={styles.supplierImgSection}>
            <img loading="lazy" src={logo} className={styles.supplierImg} />
          </div>
          <div className={styles.supplierDetailsSection}>
            <div className={clsx(styles.sectionHeading)}>
              Supplier Information
              <span> (Shipping)</span>
            </div>
            <div className={styles.supplierDetailsDiv}>
              <div className={clsx(styles.supplierDetailsCell)}>
                <div className={styles.label}>Company Name</div>
                <div className={styles.value}>
                  {viewData?.Strategies_table?.supply_info_data?.company_name
                    ? viewData?.Strategies_table?.supply_info_data?.company_name
                    : "-"}
                </div>
              </div>
              <div className={clsx(styles.supplierDetailsCell)}>
                <div className={styles.label}>Vendor Code</div>
                <div className={styles.value}>
                  {viewData?.Strategies_table?.supply_info_data?.vendor_code
                    ? viewData?.Strategies_table?.supply_info_data?.vendor_code
                    : "-"}
                </div>
              </div>
              <div className={clsx(styles.supplierDetailsCell)}>
                <div className={styles.label}>Company Address</div>
                <div className={styles.value}>
                  {viewData?.Strategies_table?.supply_info_data?.company_address
                    ? viewData?.Strategies_table?.supply_info_data
                      ?.company_address
                    : "-"}
                </div>
              </div>
              <div className={clsx(styles.supplierDetailsCell)}>
                <div className={styles.label}>State, Country</div>
                <div className={styles.value}>
                  {viewData?.Strategies_table?.supply_info_data?.state
                    ? viewData?.Strategies_table?.supply_info_data?.state
                    : "-"}
                </div>
              </div>
              <div className={clsx(styles.supplierDetailsCell)}>
                <div className={styles.label}>Pkg Person Contact Name</div>
                <div className={styles.value}>
                  {" "}
                  {viewData?.Strategies_table?.supply_info_data?.contact_person
                    ? viewData?.Strategies_table?.supply_info_data
                      ?.contact_person
                    : "-"}{" "}
                </div>
              </div>
              <div className={clsx(styles.supplierDetailsCell)}>
                <div className={styles.label}>Tel No</div>
                <div className={styles.value}>
                  {viewData?.Strategies_table?.supply_info_data?.tel_no
                    ? viewData?.Strategies_table?.supply_info_data?.tel_no
                    : "-"}
                </div>
              </div>
              <div className={clsx(styles.supplierDetailsCell)}>
                <div className={styles.label}>Email</div>
                <div className={styles.value}>
                  {viewData?.Strategies_table?.supply_info_data?.email
                    ? viewData?.Strategies_table?.supply_info_data?.email
                    : "-"}
                </div>
              </div>
              <div className={styles.supplierDetailsCell}>
                <div className={styles.label}>Fax No</div>
                <div className={styles.value}>
                  {viewData?.Strategies_table?.supply_info_data?.fax_no
                    ? viewData?.Strategies_table?.supply_info_data?.fax_no
                    : "-"}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.approvalSection}>
          <div className={styles.approvalType}>
            <div className={styles.label}>Approval Type</div>
            <div className={styles.value}>
              {viewData?.Strategies_table?.approval_info?.approval_type
                ? viewData?.Strategies_table?.approval_info?.approval_type
                : "-"}
            </div>
          </div>
          <div className={styles.approvalStatus}>
            <div className={styles.label}>Status</div>
            <div className={styles.value}>
              {viewData?.Strategies_table?.approval_info?.approval_status
                ? viewData?.Strategies_table?.approval_info?.approval_status
                : "-"}
            </div>
          </div>
          <div className={styles.approvalDate}>
            <div className={styles.label}>Date of Approval</div>
            <div className={styles.value}>
              {viewData?.Strategies_table?.approval_info?.approval_date
                ? formatDate(
                  viewData?.Strategies_table?.approval_info?.approval_date
                )
                : "-"}
            </div>
          </div>
        </div>

        <div className={styles.programAndPartInformationSection}>
          <div className={styles.sectionHeading}>
            1. PROGRAM AND PART INFORMATION (TMPVL/ TPEM)
          </div>
          <div className={styles.programAndPartInformationTable}>
            <div
              className={clsx(
                styles.receivingLocation,
                styles.programAndPartInformationDetailsCell
              )}
            >
              <div className={styles.label}>Tata Motors Receiving Location</div>
              <div className={styles.value}>
                {viewData?.Strategies_table?.part_info_data?.receiving_location
                  ? viewData?.Strategies_table?.part_info_data
                    ?.receiving_location
                  : "-"}
              </div>
            </div>
            <div
              className={clsx(
                styles.DetailsCell,
                styles.programAndPartInformationDetailsCell
              )}
            >
              <div className={styles.label}>Annual Volume (Projected)</div>
              <div className={styles.value}>
                {viewData?.Strategies_table?.part_info_data?.annual_volume
                  ? viewData?.Strategies_table?.part_info_data?.annual_volume
                  : "-"}
              </div>
            </div>
            <div
              className={clsx(
                styles.tmlPartNo,
                styles.programAndPartInformationDetailsCell
              )}
            >
              <div className={styles.label}>Part No</div>
              {viewData?.Strategies_table?.part_info_data?.part_no ===
                "As per Annexure" ? (
                <div
                  className={clsx(styles.value, styles.annexureDiv)}
                  onClick={() => {
                    setAnnexureModalOpen(true);
                  }}
                >
                  {viewData?.Strategies_table?.part_info_data?.part_no
                    ? viewData?.Strategies_table?.part_info_data?.part_no
                    : "-"}
                </div>
              ) : (
                <div className={clsx(styles.value)}>
                  {viewData?.Strategies_table?.part_info_data?.part_no
                    ? viewData?.Strategies_table?.part_info_data?.part_no
                    : "-"}
                </div>
              )}
            </div>
            <div
              className={clsx(
                styles.noOfPartsPerVehicle,
                styles.programAndPartInformationDetailsCell
              )}
            >
              <div className={styles.label}>No. of Parts per vehicle</div>
              <div className={styles.value}>
                {viewData?.Strategies_table?.part_info_data?.part_per_vehicle
                  ? viewData?.Strategies_table?.part_info_data?.part_per_vehicle
                  : "-"}
              </div>
            </div>
            <div
              className={clsx(
                styles.tmlPartDescription,
                styles.programAndPartInformationDetailsCell
              )}
            >
              <div className={styles.label}>Part Description</div>
              <div className={styles.value}>
                {viewData?.Strategies_table?.part_info_data?.part_description
                  ? viewData?.Strategies_table?.part_info_data?.part_description
                  : "-"}
              </div>
            </div>
            <div
              className={clsx(
                styles.modelsApplicable,
                styles.programAndPartInformationDetailsCell
              )}
            >
              <div className={styles.label}>Models Applicable</div>
              <div className={styles.value}>
                {viewData?.Strategies_table?.part_info_data?.models_applicable
                  ? viewData?.Strategies_table?.part_info_data
                    ?.models_applicable
                  : "-"}
              </div>
            </div>
            <div
              className={clsx(
                styles.partWeight,
                styles.programAndPartInformationDetailsCell
              )}
            >
              <div className={styles.label}>Part Weight (Kg)</div>
              <div className={styles.value}>
                {viewData?.Strategies_table?.part_info_data?.part_weight
                  ? viewData?.Strategies_table?.part_info_data?.part_weight
                  : "-"}
              </div>
            </div>
            <div
              className={clsx(
                styles.packagingCost,
                styles.programAndPartInformationDetailsCell
              )}
            >
              <div className={styles.label}>Packaging Cost / Part</div>
              {viewAccess ? (
                <div className={styles.value}>
                  {viewData?.Strategies_table?.part_info_data
                    ?.supplier_packaging_cost
                    ? /^[.0-9]+$/.test(
                      viewData?.Strategies_table?.part_info_data
                        ?.supplier_packaging_cost
                    )
                      ? parseFloat(
                        viewData?.Strategies_table?.part_info_data
                          ?.supplier_packaging_cost
                      )?.toFixed(2)
                      : viewData?.Strategies_table?.part_info_data
                        ?.supplier_packaging_cost
                    : "-"}
                </div>
              ) : (
                "-"
              )}
            </div>
            <div
              className={clsx(
                styles.partDimension,
                styles.programAndPartInformationDetailsCell
              )}
            >
              <div className={styles.label}>
                Part Dimensions (L x W x H) (mm)
              </div>
              <div className={styles.value}>
                {viewData?.Strategies_table?.part_info_data?.part_dimension
                  ? viewData?.Strategies_table?.part_info_data?.part_dimension
                  : "-"}
              </div>
            </div>
            <div
              className={clsx(
                styles.transportationCost,
                styles.programAndPartInformationDetailsCell
              )}
            >
              <div className={styles.label}>Transportation Cost / Part</div>
              {viewAccess ? (
                <div className={styles.value}>
                  {viewData?.Strategies_table?.part_info_data
                    ?.supplier_transport_cost
                    ? /^[.0-9]+$/.test(
                      viewData?.Strategies_table?.part_info_data
                        ?.supplier_transport_cost
                    )
                      ? parseFloat(
                        viewData?.Strategies_table?.part_info_data
                          ?.supplier_transport_cost
                      )?.toFixed(2)
                      : viewData?.Strategies_table?.part_info_data
                        ?.supplier_transport_cost
                    : "-"}
                </div>
              ) : (
                "-"
              )}
            </div>
          </div>
        </div>

        <div className={styles.visualReferencesSection}>
          <div className={styles.sectionHeading}>
            2. Visual References <span>(Part & Packaging)</span>
          </div>
          <div className={styles.visualReferencesDiv}>
            <div className={styles.visualReferencesImgSection}>
              <div className={styles.visualReferencesHeader}>
                2.1- Part Only
              </div>
              <div className={styles.visualReferencesImgDiv}>
                <ImageComponent
                  imagePath={
                    viewData?.Strategies_table?.visual_reference
                      ?.part_only_image
                  }
                />
              </div>
            </div>
            <div className={styles.visualReferencesImgSection}>
              <div className={styles.visualReferencesHeader}>
                2.2- Part + Dunn Age + Primary Packaging
              </div>
              <div className={styles.visualReferencesImgDiv}>
                <ImageComponent
                  imagePath={
                    viewData?.Strategies_table?.visual_reference
                      ?.part_dunnage_primary_packaging_image
                  }
                />
              </div>
            </div>
            <div className={styles.visualReferencesImgSection}>
              <div className={styles.visualReferencesHeader}>
                2.3- Primary + Secondary Packaging
              </div>
              <div className={styles.visualReferencesImgDiv}>
                <ImageComponent
                  imagePath={
                    viewData?.Strategies_table?.visual_reference
                      ?.primary_plus_secondary_packaging_image
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.packingInformationSection}>
          <div className={styles.sectionHeading}>3. Packing Information</div>
          <div className={styles.packingInformationDetailsSection}>
            <div
              className={clsx(
                styles.packingInformationHeader,
                styles.packingInformationCell,
                styles.packingInformationCellPadding
              )}
            >
              Specifications
            </div>
            <div
              className={clsx(
                styles.packingInformationHeader,
                styles.packingInformationCellPadding
              )}
            >
              Primary Packaging
            </div>
            <div
              className={clsx(
                styles.packingInformationHeader,
                styles.packingInformationCellPadding
              )}
            >
              Secondary Packaging
            </div>

            <div
              className={clsx(
                styles.div6,
                styles.packingInformationCell,
                styles.packingInformationCellPadding
              )}
            >
              Density (Qty of parts)
            </div>
            <div
              className={clsx(
                styles.div2,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_density
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_density
                : "-"}
            </div>
            <div
              className={clsx(
                styles.div2,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_density
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_density
                : "-"}
            </div>

            <div
              className={clsx(
                styles.div7,
                styles.packingInformationCell,
                styles.packingInformationCellPadding
              )}
            >
              Packaging Strategy
            </div>
            <div
              className={clsx(
                styles.div3,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_packaging_strategy
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_packaging_strategy
                : "-"}
            </div>
            <div
              className={clsx(
                styles.div3,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_packaging_strategy
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_packaging_strategy
                : "-"}
            </div>

            <div
              className={clsx(
                styles.div8,
                styles.packingInformationCell,
                styles.packingInformationCellPadding
              )}
            >
              Carton Code
            </div>
            <div
              className={clsx(
                styles.div4,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_carton_code
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_carton_code
                : "-"}
            </div>
            <div
              className={clsx(
                styles.div4,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_carton_Code
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_carton_Code
                : "-"}
            </div>

            <div
              className={clsx(
                styles.div9,
                styles.packingInformationCell,
                styles.packingInformationCellPadding
              )}
            >
              Carton Type (Design)
            </div>
            <div
              className={clsx(
                styles.div5,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_carton_type
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_carton_type
                : "-"}
            </div>
            <div
              className={clsx(
                styles.div5,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_carton_Type
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_carton_Type
                : "-"}
            </div>

            <div
              className={clsx(
                styles.div10,
                styles.packingInformationCell,
                styles.packingInformationCellPadding
              )}
            >
              Packaging Material Type
            </div>
            <div
              className={clsx(
                styles.div6,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_packaging_material
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_packaging_material
                : "-"}
            </div>
            <div
              className={clsx(
                styles.div6,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_packaging_material
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_packaging_material
                : "-"}
            </div>

            <div
              className={clsx(
                styles.div11,
                styles.packingInformationCell,
                styles.packingInformationCellPadding
              )}
            >
              Securement / Closure Type
            </div>
            <div
              className={clsx(
                styles.div7,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_securement
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_securement
                : "-"}
            </div>
            <div
              className={clsx(
                styles.div7,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_securement
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_securement
                : "-"}
            </div>

            <div
              className={clsx(
                styles.div12,
                styles.packingInformationCell,
                styles.packingInformationCellPadding
              )}
            >
              Total Loaded Wt. (Kg - Full)
            </div>
            <div
              className={clsx(
                styles.div8,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_total_Loaded
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_total_Loaded
                : "-"}
            </div>
            <div
              className={clsx(
                styles.div8,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_total_loaded
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_total_loaded
                : "-"}
            </div>

            <div
              className={clsx(
                styles.div13,
                styles.packingInformationCell,
                styles.packingInformationCellPadding
              )}
            >
              Outside Dimension (L X W X H) (mm)
            </div>
            <div
              className={clsx(styles.div9, styles.packingInformationMultiCol)}
            >
              <div
                className={clsx(
                  styles.div10,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.primary_packaging_info?.primary_outside_dimension.split(
                  ","
                )[0]
                  ? viewData?.Strategies_table?.primary_packaging_info?.primary_outside_dimension.split(
                    ","
                  )[0]
                  : "-"}
              </div>
              <div
                className={clsx(
                  styles.div11,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.primary_packaging_info?.primary_outside_dimension.split(
                  ","
                )[1]
                  ? viewData?.Strategies_table?.primary_packaging_info?.primary_outside_dimension.split(
                    ","
                  )[1]
                  : "-"}
              </div>
              <div
                className={clsx(
                  styles.div12,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.primary_packaging_info?.primary_outside_dimension.split(
                  ","
                )[2]
                  ? viewData?.Strategies_table?.primary_packaging_info?.primary_outside_dimension.split(
                    ","
                  )[2]
                  : "-"}
              </div>
            </div>
            <div
              className={clsx(styles.div9, styles.packingInformationMultiCol)}
            >
              <div
                className={clsx(
                  styles.div10,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.secondary_packaging_info?.secondary_outside_dimension.split(
                  ","
                )[0]
                  ? viewData?.Strategies_table?.secondary_packaging_info?.secondary_outside_dimension.split(
                    ","
                  )[0]
                  : "-"}
              </div>
              <div
                className={clsx(
                  styles.div11,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.secondary_packaging_info?.secondary_outside_dimension.split(
                  ","
                )[1]
                  ? viewData?.Strategies_table?.secondary_packaging_info?.secondary_outside_dimension.split(
                    ","
                  )[1]
                  : "-"}
              </div>
              <div
                className={clsx(
                  styles.div12,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.secondary_packaging_info?.secondary_outside_dimension.split(
                  ","
                )[2]
                  ? viewData?.Strategies_table?.secondary_packaging_info?.secondary_outside_dimension.split(
                    ","
                  )[2]
                  : "-"}
              </div>
            </div>

            <div
              className={clsx(
                styles.div14,
                styles.packingInformationCell,
                styles.packingInformationCellPadding
              )}
            >
              Dunnage & Description
            </div>
            <div
              className={clsx(styles.div13, styles.packingInformationMultiCol)}
            >
              <div
                className={clsx(
                  styles.div14,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.primary_packaging_info?.primary_dunnage_description.split(
                  ","
                )[0]
                  ? viewData?.Strategies_table?.primary_packaging_info?.primary_dunnage_description.split(
                    ","
                  )[0]
                  : "-"}
              </div>
              <div
                className={clsx(
                  styles.div15,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.primary_packaging_info?.primary_dunnage_description.split(
                  ","
                )[1]
                  ? viewData?.Strategies_table?.primary_packaging_info?.primary_dunnage_description.split(
                    ","
                  )[1]
                  : "-"}
              </div>
            </div>
            <div
              className={clsx(styles.div13, styles.packingInformationMultiCol)}
            >
              <div
                className={clsx(
                  styles.div14,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.secondary_packaging_info?.secondary_dunnage_description.split(
                  ","
                )[0]
                  ? viewData?.Strategies_table?.secondary_packaging_info?.secondary_dunnage_description.split(
                    ","
                  )[0]
                  : "-"}
              </div>
              <div
                className={clsx(
                  styles.div15,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.secondary_packaging_info?.secondary_dunnage_description.split(
                  ","
                )[1]
                  ? viewData?.Strategies_table?.secondary_packaging_info?.secondary_dunnage_description.split(
                    ","
                  )[1]
                  : "-"}
              </div>
            </div>

            <div
              className={clsx(
                styles.div15,
                styles.packingInformationCell,
                styles.packingInformationCellPadding
              )}
            >
              Labels (Quantity / Location)
            </div>
            <div
              className={clsx(styles.div16, styles.packingInformationMultiCol)}
            >
              <div
                className={clsx(
                  styles.div17,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.primary_packaging_info?.primary_labels.split(
                  ","
                )[0]
                  ? viewData?.Strategies_table?.primary_packaging_info?.primary_labels.split(
                    ","
                  )[0]
                  : "-"}
              </div>
              <div
                className={clsx(
                  styles.div18,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.primary_packaging_info?.primary_labels.split(
                  ","
                )[1]
                  ? viewData?.Strategies_table?.primary_packaging_info?.primary_labels.split(
                    ","
                  )[1]
                  : "-"}
              </div>
            </div>
            <div
              className={clsx(styles.div16, styles.packingInformationMultiCol)}
            >
              <div
                className={clsx(
                  styles.div17,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.secondary_packaging_info?.secondary_labels.split(
                  ","
                )[0]
                  ? viewData?.Strategies_table?.secondary_packaging_info?.secondary_labels.split(
                    ","
                  )[0]
                  : "-"}
              </div>
              <div
                className={clsx(
                  styles.div18,
                  styles.packingInformationCellPadding
                )}
              >
                {viewData?.Strategies_table?.secondary_packaging_info?.secondary_labels.split(
                  ","
                )[1]
                  ? viewData?.Strategies_table?.secondary_packaging_info?.secondary_labels.split(
                    ","
                  )[1]
                  : "-"}
              </div>
            </div>

            <div
              className={clsx(
                styles.div16,
                styles.packingInformationCell,
                styles.packingInformationCellPadding
              )}
            >
              Container Ownership
            </div>
            <div
              className={clsx(
                styles.div19,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_container_ownership
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_container_ownership
                : "-"}
            </div>
            <div
              className={clsx(
                styles.div19,
                styles.packingInformationCellPadding
              )}
            >
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_container_ownership
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_container_ownership
                : "-"}
            </div>
            <div className={clsx(styles.div16, styles.packingInformationCell, styles.packingInformationCellPadding)}>
              Type of Plastic Packaging Supplied Along with Parts
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_type_of_plastic_packaging_supplied
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_type_of_plastic_packaging_supplied
                : "-"}
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_type_of_plastic_packaging_supplied
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_type_of_plastic_packaging_supplied
                : "-"}
            </div>

            <div className={clsx(styles.div16, styles.packingInformationCell, styles.packingInformationCellPadding)}>
              Is the packaging collected and taken back by Supplier
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_is_the_packaging_collected
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_is_the_packaging_collected
                : "-"}
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_is_the_packaging_collected
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_is_the_packaging_collected
                : "-"}
            </div>

            <div className={clsx(styles.div16, styles.packingInformationCell, styles.packingInformationCellPadding)}>
              Are you complying to PWM EPR Rules (Plastic Waste Management)
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_complying_to_pwm_epr_rules
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_complying_to_pwm_epr_rules
                : "-"}
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_complying_to_pwm_epr_rules
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_complying_to_pwm_epr_rules
                : "-"}
            </div>

            <div className={clsx(styles.div16, styles.packingInformationCell, styles.packingInformationCellPadding)}>
              Share your PWM EPR Registration No. (As a brand owner)
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_pwm_epr_registration_no
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_pwm_epr_registration_no
                : "-"}
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_pwm_epr_registration_no
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_pwm_epr_registration_no
                : "-"}
            </div>

            <div className={clsx(styles.div16, styles.packingInformationCell, styles.packingInformationCellPadding)}>
              Share your plastic packaging supplier PWM EPR Registration Number (As a producer/manufacturer)
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_plastic_packaging_supplier_pwm_epr_registration_no
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_plastic_packaging_supplier_pwm_epr_registration_no
                : "-"}
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_plastic_packaging_supplier_pwm_epr_registration_no
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_plastic_packaging_supplier_pwm_epr_registration_no
                : "-"}
            </div>

            <div className={clsx(styles.div16, styles.packingInformationCell, styles.packingInformationCellPadding)}>
              Are you complying with the PWM EPR Labeling Requirement
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_pwm_epr_labeling_requirement
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_pwm_epr_labeling_requirement
                : "-"}
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_pwm_epr_labeling_requirement
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_pwm_epr_labeling_requirement
                : "-"}
            </div>

            <div className={clsx(styles.div16, styles.packingInformationCell, styles.packingInformationCellPadding)}>
              Are you complying with the PWM EPR Plastic Packaging Recycling Requirement
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_pwm_epr_plastic_packaging_recycling_requirement
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_pwm_epr_plastic_packaging_recycling_requirement
                : "-"}
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_pwm_epr_plastic_packaging_recycling_requirement
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_pwm_epr_plastic_packaging_recycling_requirement
                : "-"}
            </div>

            <div className={clsx(styles.div16, styles.packingInformationCell, styles.packingInformationCellPadding)}>
              Are you complying with the PWM EPR Plastic Packaging Recycled Content Requirement
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_pwm_epr_plastic_packaging_recycled_content_requirement
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_pwm_epr_plastic_packaging_recycled_content_requirement
                : "-"}
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_plastic_packaging_recycled_content_requirement
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_plastic_packaging_recycled_content_requirement
                : "-"}
            </div>

            <div className={clsx(styles.div16, styles.packingInformationCell, styles.packingInformationCellPadding)}>
              What is the current % of recycled content in the plastic packaging of the parts
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_current_percent_recycled_content_in_plastic_packaging
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_current_percent_recycled_content_in_plastic_packaging
                : "-"}

            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_current_percent_recycled_content_plastic_packaging
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_current_percent_recycled_content_plastic_packaging
                : "-"}
            </div>

            <div className={clsx(styles.div16, styles.packingInformationCell, styles.packingInformationCellPadding)}>
              Remarks/Any Other Details
            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.primary_packaging_info
                ?.primary_remarks
                ? viewData?.Strategies_table?.primary_packaging_info
                  ?.primary_remarks
                : "-"}

            </div>
            <div className={clsx(styles.div19, styles.packingInformationCellPadding)}>
              {viewData?.Strategies_table?.secondary_packaging_info
                ?.secondary_remarks
                ? viewData?.Strategies_table?.secondary_packaging_info
                  ?.secondary_remarks
                : "-"}
            </div>
          </div>
          <div className={styles.label}>
            For More Details , Visit the link: <a className={styles.value} href="https://eprplastic.cpcb.gov.in/#/plastic/home" target="_blank"> https://eprplastic.cpcb.gov.in/#/plastic/home </a>
          </div>
        </div>

        <div className={clsx(styles.miscellaneousCommentSection, styles.labellingGuidelinesSection)}>
          <div className={clsx(styles.sectionHeading, styles.labellingGuidelinesHeader)}>
            Labelling Guidelines on Plastic Packaging
          </div>
          <div className={clsx(styles.labellingGuidelinedataSection)}>
            Mention the name of the packaging manufacturer, thickness of the plastic, type of plastic, PWM-EPR registration number, buy-back price, etc on the plastic packaging material.
          </div>
        </div>

        <div className={styles.shippingLogisticsSection}>
          <div className={styles.sectionHeading}>4. Shipping & Logistics</div>
          <div className={styles.shippingLogisticsDetailsSection}>
            <div
              className={clsx(styles.div4, styles.shippingLogisticsLabelCell)}
            >
              Transportation Mode (Vehicle type / Size)
            </div>
            <div
              className={clsx(styles.div2, styles.shippingLogisticsValueCell)}
            >
              {viewData?.Strategies_table?.shipping_info?.transportation_mode
                ? viewData?.Strategies_table?.shipping_info?.transportation_mode
                : "-"}
            </div>
            <div
              className={clsx(
                styles.theoreticalCubicUtilisationDiv,
                styles.shippingLogisticsValueCell,
                styles.rightSectionSpan
              )}
            >
              Theoretical Cubic Utilisation / No of Parts per Transport mode
            </div>
            <div
              className={clsx(
                styles.theoreticalCubicUtilisation,
                styles.shippingLogisticsValueCell,
                styles.rightSectionSpan
              )}
            >
              {viewData?.Strategies_table?.shipping_info
                ?.theoretical_cubic_utilisation
                ? viewData?.Strategies_table?.shipping_info
                  ?.theoretical_cubic_utilisation
                : "-"}
            </div>

            <div
              className={clsx(styles.div5, styles.shippingLogisticsLabelCell)}
            >
              Pallet Dimensions (L X W X H) (mm)
            </div>
            <div
              className={clsx(styles.div3, styles.shippingLogisticsMultiCol)}
            >
              <div
                className={clsx(styles.div4, styles.shippingLogisticsValueCell)}
              >
                {viewData?.Strategies_table?.shipping_info?.pallet_dimensions.split(
                  ","
                )[0]
                  ? viewData?.Strategies_table?.shipping_info?.pallet_dimensions.split(
                    ","
                  )[0]
                  : "-"}
              </div>
              <div
                className={clsx(styles.div5, styles.shippingLogisticsValueCell)}
              >
                {viewData?.Strategies_table?.shipping_info?.pallet_dimensions.split(
                  ","
                )[1]
                  ? viewData?.Strategies_table?.shipping_info?.pallet_dimensions.split(
                    ","
                  )[1]
                  : "-"}
              </div>
              <div
                className={clsx(styles.div6, styles.shippingLogisticsValueCell)}
              >
                {viewData?.Strategies_table?.shipping_info?.pallet_dimensions.split(
                  ","
                )[2]
                  ? viewData?.Strategies_table?.shipping_info?.pallet_dimensions.split(
                    ","
                  )[2]
                  : "-"}
              </div>
            </div>

            <div
							className={clsx(styles.div4, styles.shippingLogisticsLabelCell)}
						>
							No. of Pallets per vehicle
						</div>
						<div
							className={clsx(styles.div2, styles.shippingLogisticsValueCell)}
						>
							{viewData?.Strategies_table?.shipping_info
								?.no_of_pallets_per_vehicle
								? viewData?.Strategies_table?.shipping_info
										?.no_of_pallets_per_vehicle
								: '-'}
						</div>

						<div
							className={clsx(styles.div5, styles.shippingLogisticsLabelCell)}
						>
							Stackable/ Non stackable (If "Stackable" then no. of stacking
							allowed)
						</div>
						<div
							className={clsx(styles.div3, styles.shippingLogisticsMultiCol)}
						>
							<div
								className={clsx(styles.div4, styles.shippingLogisticsValueCell)}
							>
								{viewData?.Strategies_table?.shipping_info?.stackable_non_stackable
                  ? viewData?.Strategies_table?.shipping_info?.stackable_non_stackable.split("," )[0]
									  ? viewData?.Strategies_table?.shipping_info?.stackable_non_stackable.split(",")[0]
                      : viewData?.Strategies_table?.shipping_info?.stackable_non_stackable
									: '-'}
							</div>
							<div
								className={clsx(styles.div5, styles.shippingLogisticsValueCell)}
							>
								{viewData?.Strategies_table?.shipping_info?.stackable_non_stackable
                  ? viewData?.Strategies_table?.shipping_info?.stackable_non_stackable.split("," )[1]
									  ? viewData?.Strategies_table?.shipping_info?.stackable_non_stackable.split(",")[1]
                      : viewData?.Strategies_table?.shipping_info?.stackable_non_stackable
									: '-'}
							</div>
						</div>

            <div
              className={clsx(styles.div6, styles.shippingLogisticsLabelCell)}
            >
              Sec Packaging per transit modes
            </div>
            <div
              className={clsx(styles.div7, styles.shippingLogisticsValueCell)}
            >
              {viewData?.Strategies_table?.shipping_info
                ?.sec_packaging_per_transit_modes
                ? viewData?.Strategies_table?.shipping_info
                  ?.sec_packaging_per_transit_modes
                : "-"}
            </div>

            <div
              className={clsx(styles.div7, styles.shippingLogisticsLabelCell)}
            >
              No of Pry Packs per Sec Packs
            </div>
            <div
              className={clsx(styles.div8, styles.shippingLogisticsValueCell)}
            >
              {viewData?.Strategies_table?.shipping_info
                ?.no_of_pry_packs_per_sec_packs
                ? viewData?.Strategies_table?.shipping_info
                  ?.no_of_pry_packs_per_sec_packs
                : "-"}
            </div>

            <div
              className={clsx(styles.div8, styles.shippingLogisticsLabelCell)}
            >
              INCO Terms
            </div>
            <div
              className={clsx(styles.div9, styles.shippingLogisticsValueCell)}
            >
              {viewData?.Strategies_table?.shipping_info?.inco_terms
                ? viewData?.Strategies_table?.shipping_info?.inco_terms
                : "-"}
            </div>

            <div
              className={clsx(styles.div9, styles.shippingLogisticsLabelCell)}
            >
              Hazardous Material Class
            </div>
            <div
              className={clsx(styles.div10, styles.shippingLogisticsValueCell)}
            >
              {viewData?.Strategies_table?.shipping_info
                ?.hazardous_material_class
                ? viewData?.Strategies_table?.shipping_info
                  ?.hazardous_material_class
                : "-"}
            </div>
            <div
              className={clsx(styles.div5, styles.shippingLogisticsMultiCol)}
            >
              <div
                className={clsx(
                  styles.div6,
                  styles.shippingLogisticsValueCell,
                  styles.colorGreen,
                  styles.rightSectionSpan
                )}
              >
                Compliant (&gt;85%)
              </div>
              <div
                className={clsx(
                  styles.div8,
                  styles.shippingLogisticsValueCell,
                  styles.colorRed,
                  styles.rightSectionSpan
                )}
              >
                Non-Compliant (&lt;85%)
              </div>
            </div>
            <div
              className={clsx(styles.div10, styles.shippingLogisticsLabelCell)}
            >
              loop Size (for Returnable)
            </div>
            <div
              className={clsx(styles.div11, styles.shippingLogisticsValueCell)}
            >
              {viewData?.Strategies_table?.shipping_info?.loop_size
                ? viewData.Strategies_table?.shipping_info?.loop_size
                : "-"}
            </div>
            <div
              className={clsx(
                styles.div9,
                styles.shippingLogisticsValueCell,
                styles.rightSectionSpan
              )}
            >
              Remarks
            </div>
            <div
              className={clsx(
                styles.div9,
                styles.shippingLogisticsValueCell,
                styles.remarksValueMergeCell,
                styles.rightSectionSpan
              )}
            >
              {viewData?.Strategies_table?.shipping_info?.remarks
                ? viewData?.Strategies_table?.shipping_info?.remarks
                : "-"}
            </div>

            <div
              className={clsx(styles.div11, styles.shippingLogisticsLabelCell)}
            >
              Life of Returnable Packaging
            </div>
            <div
              className={clsx(styles.div12, styles.shippingLogisticsValueCell)}
            >
              {viewData.Strategies_table?.shipping_info
                ?.life_returnable_packaging
                ? viewData.Strategies_table?.shipping_info
                  ?.life_returnable_packaging
                : "-"}
            </div>

            <div
              className={clsx(styles.div12, styles.shippingLogisticsLabelCell)}
            >
              Unloading & Loading responsibility
            </div>
            <div
              className={clsx(styles.div13, styles.shippingLogisticsValueCell)}
            >
              {viewData.Strategies_table?.shipping_info
                ?.unloading_loading_responsibility
                ? viewData.Strategies_table?.shipping_info
                  ?.unloading_loading_responsibility
                : "-"}
            </div>

            <div
              className={clsx(styles.div13, styles.shippingLogisticsLabelCell)}
            >
              Supply at TMPVL/TPEM (Supplier Scope)
            </div>
            <div
              className={clsx(
                styles.div14,
                styles.shippingLogisticsValueCell,
                styles.supplyAtTmlMergeValueCell
              )}
            >
              {viewData.Strategies_table?.shipping_info?.supply_tml
                ? viewData.Strategies_table?.shipping_info?.supply_tml
                : "-"}
            </div>
          </div>
          <div className={clsx(styles.notePadding, styles.colorRed)}>
            The packaging design by Tier1 supplier ensures the undamaged part
            supply till the point of use on the Tata Motors assembly line,
            irrespective of the logistic terms.
          </div>
        </div>

        <div className={clsx(styles.miscellaneousCommentSection)}>
          <div className={clsx(styles.sectionHeading)}>
            5. Miscellaneous Comment
          </div>
          <div className={clsx(styles.miscellaneousCommentDetailsSection)}>
            {viewData.Strategies_table?.approval_info?.miscellaneous_comment
              ? viewData.Strategies_table?.approval_info?.miscellaneous_comment
              : "-"}
          </div>
        </div>

        {/* <div className={clsx(styles.approvalInformation)}>
          <div className={clsx(styles.sectionHeading)}>
            6. Approval Information
          </div>
          <div className={clsx(styles.approvalInformationDetailsSection)}>
            <div
              className={clsx(
                styles.approvalInformationHeader,
                styles.approvalInformationDetailsCell
              )}
            >
              Department / Function
            </div>
            <div
              className={clsx(
                styles.approvalInformationHeader,
                styles.approvalInformationDetailsCell
              )}
            >
              Name
            </div>
            <div
              className={clsx(
                styles.approvalInformationHeader,
                styles.approvalInformationDetailsCell
              )}
            >
              Date
            </div>

            <div
              className={clsx(
                styles.approvalInformationCell,
                styles.approvalInformationDetailsCell
              )}
            >
              Packaging Person (Supplier)
            </div>
            <div
              className={clsx(
                styles.approvalInformationValueCell,
                styles.approvalInformationDetailsCell
              )}
            >
              {viewData.Strategies_table?.approval_info?.packaging_person
                ? viewData.Strategies_table?.approval_info?.packaging_person
                : "-"}
            </div>
            <div
              className={clsx(
                styles.approvalInformationValueCell,
                styles.approvalInformationDetailsCell
              )}
            >
              {viewData.Strategies_table?.approval_info?.packaging_person_date
                ? viewData.Strategies_table?.approval_info?.packaging_person_date.substring(
                  0,
                  10
                )
                : "-"}
            </div>

            <div
              className={clsx(
                styles.approvalInformationCell,
                styles.approvalInformationDetailsCell
              )}
            >
              Purchasing Buyer (TMPVL/TPEM): - 
            </div>
            <div
              className={clsx(
                styles.approvalInformationValueCell,
                styles.approvalInformationDetailsCell
              )}
            >
              {viewData.Strategies_table?.approval_info?.purchasing_buyer
                ? viewData.Strategies_table?.approval_info?.purchasing_buyer
                : "-"}
            </div>
            <div
              className={clsx(
                styles.approvalInformationValueCell,
                styles.approvalInformationDetailsCell
              )}
            >
              {viewData.Strategies_table?.approval_info?.purchasing_buyer_date
                ? viewData.Strategies_table?.approval_info?.purchasing_buyer_date.substring(
                  0,
                  10
                )
                : "-"}
            </div>

            <div
              className={clsx(
                styles.approvalInformationCell,
                styles.approvalInformationDetailsCell
              )}
            >
              SCM ( TMPVL/TPEM)- 
            </div>
            <div
              className={clsx(
                styles.approvalInformationValueCell,
                styles.approvalInformationDetailsCell
              )}
            >
              {viewData.Strategies_table?.approval_info?.scm
                ? viewData.Strategies_table?.approval_info?.scm
                : "-"}
            </div>
            <div
              className={clsx(
                styles.approvalInformationValueCell,
                styles.approvalInformationDetailsCell
              )}
            >
              {viewData.Strategies_table?.approval_info?.scm_date
                ? viewData.Strategies_table?.approval_info?.scm_date.substring(
                  0,
                  10
                )
                : "-"}
            </div>
          </div>
        </div> */}
        <div className={clsx(styles.approvalInformation, styles.recyclingGuidelines)}>
          {/* First Table: Plastic Packaging Recycling Guidelines */}
          <div className={styles.recyclingGuideLinesTable}>
            <div className={styles.recyclingHeading}>Plastic Packaging Recycling Guidelines (%)</div>
            {renderGuidelinesTable(plasticPackagingRecyclingGuidelines)}
          </div>

          {/* Second Table: Plastic Packaging Recycled Content Guidelines */}
          <div className={styles.recyclingGuideLinesTable}>
            <div className={styles.recyclingHeading}>Plastic Packaging Recycled Content Guidelines (%)</div>
            {renderGuidelinesTable(recycledContentGuidelines)}
          </div>
        </div>
      </div>

      {
        <div className={styles.tableFooter}>
          {hasEditAccess(user, commonVaribles.download_packaging_strategy) &&
						!IsUserRoleMatch('scm_buyer', user) && (
							<Button
								children={commonVaribles.excel_attachment_strategy}
								variant={constants.BUTTON_ATOMIC_COMPONENT.FEEDBACKS}
								onClick={() => {
									handleDownloadExcelFile();
								}}
							/>
          )}
          
          {hasEditAccess(user, commonVaribles.download_packaging_strategy) && (
            <Button
              children={commonVaribles.excel_update_download_strategy}
              variant={constants.BUTTON_ATOMIC_COMPONENT.FEEDBACKS}
              onClick={() => {
                handleDownloadExcelFile_V2();
              }}
            />
          )}

          {/* {hasEditAccess(user, commonVaribles.download_packaging_strategy) && (
            <Button
              children={"Download PDF"}
              variant={constants.BUTTON_ATOMIC_COMPONENT.FEEDBACKS}
              onClick={() => {
                setIsDownloadTrue(true);
                handleDownloadPDF();
              }}
            />
          )}

          {hasEditAccess(user, commonVaribles.update_packaging_strategy) && (
            <Button
              children={commonVaribles.update}
              variant={constants.BUTTON_ATOMIC_COMPONENT.FEEDBACKS}
              onClick={() => {
                SetIsUpdateStrategyModalOpen(true);
              }}
            />
          )} */}
        </div>
      }
      <input
        type="file"
        accept=".csv,.xlsx,.xls,.xlsm"
        id="input_file"
        onChange={(e) => handleExcelUpload(e)}
        hidden
      />

      {isUpdateStrategyModalOpen && (
        <UpdateStrategyModal
          open={isUpdateStrategyModalOpen}
          handleClose={() => {
            SetIsUpdateStrategyModalOpen(false);
            setErrorMessage("");
            //setexcelfile(null);
          }}
          confirmUpload={() => handleUpload()}
          openUploadFile={() => openExcelUploadFile()}
          title={commonVaribles.update_strategy_title}
          errorMsg={errorMessage}
          addmore={(e) => openExcelUploadFile(e)}
          excelfiles={excelfile}
          setExcel={setexcelfile}
          Modalloader={ismodalLoader}
        />
      )}

      {isFeedBackModalOpen && (
        // <FeedBackFormModal
        //   open={isFeedBackModalOpen}
        //   handleClose={() => {
        //     setIsFeedBackModalOpen(false);
        //   }}
        //   title={commonVaribles.bulk_data}
        //   rowData={dataset}
        //   id={parsedRow.id}
        //   plantId={parsedRow?.plant_id}
        // />

        <FeedbackModal
          sub_title={viewData?.Strategies_table?.part_info_data?.part_no}
          id={viewData?.Strategies_table?.id}
          plantId={parsedRow?.plant_id}
          Modalloader={ismodalLoader}
          open={isFeedBackModalOpen}
          handleClose={() => { setIsFeedBackModalOpen(false); }}
        />
      )}

      {isAnnexureModalOpen && (
        <AnnexureModal
          annexureData={viewData?.Strategies_table?.annexure_details}
          open={isAnnexureModalOpen}
          handleClose={() => handleCloseAnnexureModal()}
        />
      )}

      <style jsx="true">
        {`
          a {
            text-decoration: none;
            color: inherit;
          }
        `}
      </style>
    </div>
  ) : (
    <Loader />
  );
}
